import { useNavigate } from "react-router-dom";
import { DoorOpen, X } from "lucide-react";
import { Button } from "../ui/button";
import { useGameStore } from "../../store/gameStore";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Fires when the acting player's own token steps through a Door/Portal a GM linked to a Game
// Show room (instead of another map) — see door_router.py's target_show_id branch. Only shown
// to whoever actually triggered it (the websocket message is scoped to that member).
export default function GameShowPortalPrompt({ myMemberId }) {
  const pending = useGameStore((s) => s.pendingGameShowPortal);
  const setPending = useGameStore((s) => s.setPendingGameShowPortal);
  const navigate = useNavigate();

  if (!pending) return null;

  const enter = async () => {
    try {
      const { data } = await api.post(`/game-shows/join/${pending.invite_code}`, {});
      navigate(`/gameshow/${data.show_id || data.id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't step through — ask your GM");
    } finally {
      setPending(null);
    }
  };

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[75] flex items-center gap-3 px-5 py-3 rounded-full bg-black/85 backdrop-blur-md border border-[#D4AF37]/30 shadow-2xl"
      data-testid="gameshow-portal-prompt"
    >
      <DoorOpen className="w-4 h-4 text-[#D4AF37] shrink-0" />
      <span className="text-sm text-[#f1e0c5]">
        {pending.door_name || "An archway"} pulls you toward <strong>{pending.show_name}</strong>!
      </span>
      <Button data-testid="gameshow-portal-enter-button" size="sm" onClick={enter} className="rounded-full bg-[#D4AF37] text-black hover:bg-[#c19b2e] h-8">
        Enter
      </Button>
      <button data-testid="gameshow-portal-dismiss-button" onClick={() => setPending(null)} className="text-[#f1e0c5]/40 hover:text-[#f1e0c5]">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
